import { Vue, Options } from "vue-class-component";
import { Maintenance, MaintenanceAdditional } from "../../services";
import maintenanceBloc from "../../services/bloc";
import component from "../../components/component";
import { customField } from "@/components/custom-field/type";

@Options({
  components: component,
})
export class MaintenanceCreatePage extends Vue {
  maintenanceBloc = maintenanceBloc;
  maintenance = new Maintenance();

  beforeCreate(): void {
    this.maintenance.additional = new MaintenanceAdditional();
    this.maintenance.part_supplied = [];
    this.maintenance.custom_field =
      this.maintenance.custom_field ?? customField();
  }
}
